<template>
    <div v-if="config.display" :style="{'width': config.width || '100%', 'display': config.inlineLabel ? 'flex' : 'block'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

const labelComponent = {
    editorSettings: editorSettings,
    data: function () {
        return {};
    },
    mixins: [controlMixins]
};

export { labelComponent };
export default labelComponent;
</script>
